import { makeActionCreator } from '../../config/store/utils'
import { createTradedAmounts } from '../../services/charts'

export const TRADEDAMOUNT = 'TRADEDAMOUNT'
export const TRADEDAMOUNT_ERROR = 'TRADEDAMOUNT_ERROR'
export const TRADEDAMOUNT_SUCCESS = 'TRADEDAMOUNT_SUCCESS'
export const onTradedAmount = makeActionCreator(TRADEDAMOUNT)
export const onTradedAmountError = makeActionCreator(TRADEDAMOUNT_ERROR, 'payload')
export const onTradedAmountSuccess = makeActionCreator(TRADEDAMOUNT_SUCCESS, 'payload')
export const onTradedAmountThunk = updatedValue => async dispatch => {
  dispatch(onTradedAmount())

  try {
    const { data } = await createTradedAmounts({ updatedValue })

    if (data.success !== 'OK') {
      return dispatch(onTradedAmountError(data.errores))
    }

    const chartStructure = data.payload.map(({ year, data: innerData }) => ({
      amount: innerData.map(({ amount }) => amount),
      month: innerData.map(({ month }) => month),
      name: year,
      percentageAccumulative: innerData.map(({ percentAmountAcumCLP }) => percentAmountAcumCLP),
      percentageMonth: innerData.map(({ percentAmountMonthCLP }) => percentAmountMonthCLP),
      totalAmount: innerData.map(({ totalAmount }) => totalAmount)
    }))
    const csvStructure = [
      [
        'Año',
        'Mes',
        'Monto por mes (CLP)',
        'Monto acumulado (CLP)',
        'Monto porcentual mensual',
        'Monto porcentual acumulado'
      ],
      ...chartStructure.flatMap(item =>
        item.amount.map((_, index) => [
          item.name,
          item.month[index],
          item.amount[index],
          item.totalAmount[index],
          item.percentageMonth[index],
          item.percentageAccumulative[index]
        ])
      )
    ]
    const payload = { chartStructure, csvStructure }

    return dispatch(onTradedAmountSuccess(payload))
  } catch (error) {
    return dispatch(onTradedAmountError(error))
  }
}
